/** Service Desk console: Settings -> Connectors (SD-SC-17), part B: operation editor and test console. */
export const serviceConnectorsB = {
  operation: {
    backTo: "{{name}} · Mga operation",
    newTitle: "Bagong operation",
    basics: "Operation",
    name: "Pangalan",
    key: "Key (ginagamit ng mga workflow at ng assistant)",
    keyHint: "Maliliit na titik, numero at underscore. Hindi na ito mababago pagkatapos malikha ang operation.",
    kind: "Uri",
    kindHint: {
      read: "Nagbabasa ng data at walang binabago.",
      write: "Nagbabago ng data sa kabilang system. Kailangan munang makuha ng assistant ang kumpirmasyon ng kliyente.",
      destructive: "Nagbubura o nagka-cancel ng isang bagay. Kailangan ng confirmation card, at ang key nito ay tina-type para sa live na test.",
    },
    ai: "Paglalarawan para sa assistant",
    aiHint: "Kailan ito gagamitin at ano ang ibabalik nito. Ipinapakita sa model bilang paglalarawan ng tool; huwag maglagay ng secret dito. {{count}} sa {{max}}.",
    request: "Request",
    method: "Method",
    url: "URL path",
    urlHint: "Path template sa ilalim ng base URL ng aktibong environment. Gumamit ng dobleng braces para sa mga parameter, tulad ng param.order_number. Pino-percent-encode ang mga halaga at hindi sila makakapagdagdag ng segment.",
    undeclared: "Ginagamit sa path pero hindi idineklara bilang parameter: {{names}}",
    params: "Mga parameter",
    noParams: "Walang parameter. Magdagdag ng isa para sa bawat halagang dapat ibigay ng tumatawag.",
    paramName: "Pangalan ng parameter {{index}}",
    paramType: "Uri ng parameter {{index}}",
    paramDescription: "Paglalarawan ng parameter {{index}}",
    paramDescriptionPlaceholder: "Ano ang ibibigay (ipinapakita sa assistant)",
    paramRequired: "Kailangan",
    paramRemove: "Alisin ang parameter {{index}}",
    paramTypes: { string: "Teksto", number: "Numero", integer: "Buong numero", boolean: "Oo / hindi" },
    addParam: "Magdagdag ng parameter",
    paramsHint: "Ito lang ang maipapasa ng mga tumatawag. Sinusuri ang bawat isa bago may maipadala.",
    query: "Mga query parameter",
    queryHint: "Mga template na may variable, hanggang {{max}}.",
    headers: "Mga header",
    headersHint: "Tinatanggihan dito ang Authorization, API-key, cookie at x-sagot na header: mula sa naka-seal na authentication ang mga credential.",
    body: "Body",
    bodyType: "Uri ng body",
    bodyTypes: { none: "Walang body", json: "JSON", form: "Form", text: "Teksto", multipart: "Multipart", xml: "XML" },
    noBody: "Walang ipinapadalang body. Hindi kailanman may body ang GET at HEAD.",
    bodyTemplate: "Template ng body ({{type}})",
    bodyHint: {
      json: "Object o array. Ilagay sa loob ng panipi ang bawat variable; ang halagang eksaktong isang variable ay nananatili ang uri. Hanggang {{max}} KB.",
      text: "Payak na teksto na may mga variable. Isang linya ang bawat halaga. Hanggang {{max}} KB.",
      xml: "Wastong XML. Sa teksto o may panipi na attribute ilalagay ang mga variable, hindi kailanman sa loob ng tag. Hanggang {{max}} KB.",
    },
    bodyFields: "Mga field ng form",
    bodyFieldsHint: "Isang field kada hilera; kami na ang bahala sa pag-encode ng mga halaga.",
    insert: "Maglagay ng variable:",
    behaviour: "Pag-uugali",
    auth: "Authentication",
    authHint: "Mula sa aktibong environment. Palitan ito sa connector.",
    timeout: "Timeout (ms)",
    timeoutHint: "Kapag walang laman, gagamitin ang {{default}} ms ng connector.",
    successStatuses: "Mga katayuang matagumpay",
    successStatusesHint: "Mga HTTP status na ituturing na tagumpay, pinaghihiwalay ng kuwit.",
    retries: "Mga pag-ulit",
    retriesHint: "Itinatakda kada connector. Hindi kailanman bulag na inuulit ang POST at PATCH; iginagalang ang Retry-After.",
    changeDefaults: "Palitan sa connector",
    pagination: "Pagination",
    paginationStyle: "Estilo",
    paging: { none: "Wala", offset: "Offset at limit", page: "Numero ng pahina", cursor: "Cursor", link_header: "Link header" },
    pagingFields: {
      page_size: "Laki ng pahina",
      limit_param: "Parameter ng limit",
      offset_param: "Parameter ng offset",
      page_param: "Parameter ng pahina",
      first_page: "Numero ng unang pahina",
      cursor_param: "Parameter ng cursor",
      next_cursor_pointer: "Susunod na cursor sa sagot",
      items_pointer: "Mga item sa sagot",
      base_url: "Pinagmulang maaaring tukuyin ng Link",
    },
    idempotency: "Magpadala ng idempotency key",
    idempotencyHint: "Isang matatag na key kada lohikal na tawag, para ligtas na maulit ang isang write.",
    idempotencyHeader: "Pangalan ng header",
    idempotencyOffAck: "Payagan ang pag-uulit nang walang key",
    idempotencyOffAckHint: "Maaaring tumakbo nang dalawang beses sa kabilang sistema ang inulit na tawag. Kailangan ito para mailathala ang write na nakapatay ang key.",
    readOnlyPost: "Nagbabasa lang ang POST na ito",
    readOnlyPostHint: "Isang paghahanap o lookup na may body at walang binabago. Kung wala ito, hindi mailalathala ang POST bilang read.",
    kindProblems: {
      method_kind_mismatch: "Nagbabago ng data sa kabilang sistema ang method na ito, kaya hindi puwedeng read ang operation. Itugma ang uri sa method (destructive ang DELETE; write ang POST, PUT at PATCH), o kung naghahanap lang ang POST, lagyan ng tsek ang \"Nagbabasa lang ang POST na ito\".",
      idempotency_required: "Nagpapadala ng idempotency key bilang default ang write o destructive na operation para hindi maulit ang retry. Buksan ang key, o payagan ang pag-uulit nang walang key.",
      read_method_marked_mutating: "Nagbabasa lang ang GET at HEAD. Puwedeng markahan ito bilang write, pero may dagdag itong hakbang sa kumpirmasyon.",
    },
    cache: "Cache (segundo)",
    cacheHint: "Walang cache kapag walang laman. Hanggang 24 oras; hindi kailanman ibinabahagi sa pagitan ng mga organisasyon.",
    cacheNone: "Walang cache",
    mapping: "Mapping ng sagot",
    mappingAbout: "Kung saan sa sagot galing ang bawat field ng Sagot. Pinapanatili ang mga transform na naka-imbak na.",
    responseFormat: "Format ng sagot",
    items: "Mga record",
    itemsHint: "Kung nasaan ang listahan ng mga record, tulad ng $.data[*]. Kapag walang laman, isang record ang buong sagot.",
    mappingFields: "Mga field",
    noMapping: "Wala pang namamapa. Kung walang mapping, ipinapakita lang ang sagot at hindi binabasa.",
    mapTarget: "Target ng mapping {{index}}",
    mapField: "Field ng mapping {{index}}",
    mapSource: "Source ng mapping {{index}}",
    mapRemove: "Alisin ang mapping {{index}}",
    addMapping: "Magdagdag ng mapping",
    mappingHint: "Sinusuri ang mga field kapag nag-save ka. Ang mga run variable ay pinangalanang var.isang-pangalan.",
    targets: {
      variable: "Run variable",
      attribute: "Attribute",
      contact: "Contact",
      organisation: "Organisasyon",
      asset: "Asset",
      product: "Produkto",
      order: "Order",
      ticket: "Ticket",
    },
    errorMapping: "Mapping ng error",
    errorsAbout: "Ang katayuan at/o isang field ng sagot ay nagiging dahilan sa Sagot at ang mga salitang sasabihin sa kliyente. Hindi kailanman ipinapakita ang sariling mensahe ng system.",
    noErrorRules: "Walang patakaran. Gagamitin ng mga pagkabigo ang mga default ng Sagot para sa katayuan.",
    errorRule: "Patakaran {{index}}",
    errStatus: "HTTP status",
    errStatusHint: "Pinaghihiwalay ng kuwit, tulad ng 409, 422.",
    errPointer: "Field sa sagot",
    errPointerHint: "Opsyonal, tulad ng /error/code.",
    errEquals: "Katumbas ng field",
    errCode: "Dahilan sa Sagot",
    errCodes: {
      not_found: "Hindi nahanap",
      validation: "Tinanggihang input",
      conflict: "Salungatan",
      out_of_stock: "Ubos ang stock",
      auth_failed: "Nabigo ang authentication",
      rate_limited: "Naabot ang rate limit",
      upstream_error: "Error ng system",
      too_large: "Masyadong malaki ang sagot",
    },
    errEn: "Teksto para sa kliyente (English)",
    errFil: "Teksto para sa kliyente (Filipino)",
    errFilHint: "Opsyonal; English ang gagamitin kapag walang laman.",
    addErrorRule: "Magdagdag ng patakaran",
    removeRule: "Alisin ang patakaran",
    entitlements: "Sino ang maaaring tumawag",
    entStaff: "Mga miyembrong may isa sa mga permission na ito.",
    entWorkflows: "Mga nailathalang workflow ng workspace na ito.",
    entAssistant: "Ang assistant, para sa mga usapan sa mga audience na ito.",
    entContacts: "Mga beripikadong contact ng kliyente, nililimitahan ayon sa role at kakayahan.",
    entGuests: "Mga bisitang hindi naka-sign in. Mga read operation lang.",
    entConfirm: "Laging humihingi ng kumpirmasyon sa kliyente ang mga write at destructive na operation bago ito mapatakbo ng assistant.",
    orgRoles: { org_admin: "Mga admin ng organisasyon", member: "Mga miyembro ng organisasyon" },
    capabilities: { can_order: "Puwedeng mag-order", can_approve_orders: "Puwedeng mag-apruba ng order" },
    versions: "Mga bersyon",
    noVersions: "Wala pang naka-save.",
    draft: "Draft",
    current: "Kasalukuyan",
    older: "Mas luma",
    compare: "Ihambing ang v{{older}} sa v{{newer}}",
    noChanges: "Walang pagkakaiba.",
    diffLabel: "Mga pagkakaiba ng v{{older}} at v{{newer}}",
    diffFailed: "Hindi ma-load ang paghahambing.",
    rollback: "Gawing kasalukuyan ang v{{version}}",
    rolledBack: "Kasalukuyan na muli ang v{{version}}",
    versionsAbout: "Binabago ng pag-save ang draft. Ang paglalathala ay nagyeyelo rito bilang susunod na bersyon; patuloy na gumagana ang mga tumatawag na naka-pin sa mas lumang bersyon hanggang ilipat mo sila.",
    examples_one: "{{count}} naka-save na halimbawa",
    examples_other: "{{count}} naka-save na halimbawa",
    noExamples: "Wala pa. Mag-save ng isa mula sa test console.",
    deleteExample: "Burahin ang halimbawang {{name}}",
    testConsole: "Test console",
    saveDraft: "I-save ang draft",
    create: "Likhain ang operation",
    created: "Nalikha ang {{key}}",
    savedDraft: "Na-save ang draft ng {{key}}",
    publish: "Ilathala",
    published: "Nailathala ang {{key}} v{{version}}",
    publishTitle: "Ilathala ang v{{version}}?",
    publishBody: "Magiging v{{version}} ang draft, naka-freeze. Agad itong gagamitin ng mga workflow at ng assistant na sumusunod sa pinakabagong bersyon.",
    publishNote: "Ano ang nagbago (opsyonal)",
    publishNoteHint: "Ipinapakita sa kasaysayan ng bersyon.",
    publishConfirm: "Ilathala ang v{{version}}",
    unsaved: "May hindi pa na-save na pagbabago",
    fixProblems: "Ayusin muna ang mga naka-highlight na field.",
    readOnly: "Maaari mong tingnan ang operation na ito pero hindi baguhin.",
    saveFirst: "Likhain muna ang operation. Magagamit ang test console at mga bersyon kapag umiiral na ito.",
    missingTitle: "Wala rito ang operation na ito",
    missingBody: "Maaaring nabura na ito. Bumalik sa library ng mga operation.",
    errors: {
      nameRequired: "Bigyan ng pangalan ang operation.",
      keyPattern: "Gumamit ng maliliit na titik, numero at underscore, magsimula sa titik.",
      pathStart: "Dapat magsimula sa isang / ang path.",
      pathSegments: "Hindi pinapayagan ang mga dot segment at naka-encode na slash.",
      pathLong: "Masyadong mahaba ang path.",
      headerForbidden: "Nagdadala ng credential ang header na ito o itinatakda ng Sagot. Ilagay ang mga secret sa authentication ng connector.",
      tooMany: "Masyadong maraming entry.",
      paramName: "Gumamit ng titik, numero at underscore, magsimula sa titik.",
      paramDuplicate: "Dalawang parameter ang may ganitong pangalan.",
      timeoutRange: "Gumamit ng 1,000 hanggang 30,000 ms.",
      wholeNumber: "Gumamit ng buong numero.",
      statuses: "Gumamit ng mga HTTP status na pinaghihiwalay ng kuwit.",
      bodyOnGet: "Walang body ang GET o HEAD na request. Piliin ang \"Walang body\" o palitan ang method.",
      aiLong: "Masyadong mahaba ang paglalarawan.",
    },
  },
  test: {
    title: "Test console · {{key}}",
    subtitle: "Magpadala ng isang request na may mga sample na halaga. Naka-mask ang mga secret at personal na data.",
    environment: "Environment",
    dryRun: "Dry run",
    dryRunHint: "Buuin at i-log ang request nang hindi ipinapadala.",
    connectorDryRun: "Nasa dry-run mode ang connector na ito, kaya walang ipinapadala.",
    liveWrite: "Magpapadala ito ng totoong write sa {{environment}}. Gamitin ang sandbox maliban kung sinasadya mo.",
    samples: "Mga sample na halaga",
    noSamples: "Walang binabasang variable ang operation na ito.",
    samplesHint: "Hindi itinatakda ang mga walang laman. Ginagamit ng test ang operation ayon sa nasa screen, kasama ang mga hindi pa na-save na pagbabago.",
    typeToConfirm: "I-type ang {{key}} para kumpirmahin",
    typeToConfirmHint: "Kailangang i-type ang key ng isang destructive na operation para sa live na test.",
    buildRequest: "Buuin ang request",
    send: "Ipadala",
    limit: "10 test kada minuto. Nilo-log bilang test.",
    resultLabel: "Resulta ng test",
    worked: "Gumana · {{status}}",
    dryRunDone: "Hindi ipinadala (dry run)",
    refusedChip: "Tinanggihan, hindi ipinadala",
    failedChip: "Nabigo",
    attempts_one: "{{count}} pagtatangka",
    attempts_other: "{{count}} pagtatangka",
    draftTested: "Sinubok bilang draft",
    request: "Request na ipinadala",
    requestDry: "Request na binuo",
    requestLabel: "Raw na request, naka-mask ang mga secret",
    response: "Sagot",
    responseLabel: "Raw na sagot, naka-mask ang personal na data",
    truncated: "Pinutol ang sagot para sa display.",
    mapping: "Preview ng mapping",
    noMapping: "Walang namapa.",
    records: "Mga namapang record",
    masked: "Naka-mask: mga credential at field na mukhang personal (pangalan, e-mail, numero ng telepono). Data ang sagot; hindi ito kailanman binabasa bilang utos.",
    exampleLabel: "Pangalan ng halimbawa",
    exampleName: "Takbo ng test",
    saveExample: "I-save bilang halimbawa",
    exampleSaved: "Na-save ang halimbawa (naka-mask)",
    refuse: {
      invalid_params: "May kulang o maling uri ang isang parameter.",
      template: "Hindi mabuo ang template ng request.",
      blocked_destination: "Hindi pinapayagan ang address ng environment: public na https address lang ang matatawagan.",
      auth_config: "Hindi tama ang pagkaka-set up ng authentication: suriin ang mga secret.",
      connector_inactive: "Hindi aktibo ang connector.",
      environment_not_found: "Walang ganyang environment.",
      not_published: "Walang bersyong mapapatakbo ang operation na ito.",
      quota_exceeded: "Ubos na ang buwanang alokasyon ng mga tawag ng plan.",
      confirmation_required: "Kailangan muna ng kumpirmasyon.",
      type_to_confirm: "I-type ang key ng operation para kumpirmahin ang destructive na test.",
      not_entitled: "Hindi ka pinapayagang patakbuhin ito.",
    },
    refuseFallback: "Hindi ipinadala: {{code}}.",
    failure: {
      refused: "Tinanggihan ang request bago ipinadala.",
      blocked_destination: "Hinaharang ang address na iyon. Sa mga pampublikong HTTPS host lang tumatawag ang Sagot at muling sinusuri ang address sa bawat pagtatangka.",
      timeout: "Hindi sumagot ang system sa takdang oras.",
      connection: "Hindi makakonekta ang Sagot sa system.",
      too_large: "Masyadong malaki ang sagot.",
      content_type: "Hindi nasa inaasahang format ang sagot.",
      redirect: "Nag-redirect ang system at hindi sinusundan ang mga redirect.",
      http_status: "Sumagot ang system ng error na katayuan.",
      rate_limited: "Sinabi ng system o ng rate limit ng connector na masyadong maraming request.",
      circuit_open: "Bukas ang circuit breaker pagkatapos ng paulit-ulit na pagkabigo. Susubok itong muli maya-maya.",
      deadline: "Naubusan ng oras ang tawag.",
    },
    failureFallback: "Nabigo ang tawag: {{code}}.",
  },
};
